import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateComponent } from '../../sprinklers/certificate-sprinklers/certificate.component';

@Component({
  selector: 'authority-labs-certificate-gas-extinguishing-system',
  templateUrl: './certificate-gas-extinguishing-system.component.html',
  styleUrls: ['./certificate-gas-extinguishing-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateGasExtinguishingSystemComponent extends CertificateComponent {}
